import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'Gure aukera',
  bestPriceBadge: 'Prezio onena',
  regulatedNotice: {
    prescriptionOnly: 'Errezetarekin bakarrik',
    professionalUse: 'Erabilera profesionala',
    fromVeterinarian: 'Zure albaitariaren bidez lor daiteke',
    fromPharmacist: 'Farmazian lor daiteke',
    noOnlinePurchase: 'Ez da sarean saltzen',
    professionalSupply: 'Hornitzaile profesionalen bidez saltzen da',
    whyNoLink: 'Produktu hau aztertzen dugu, baina ez dugu haren estekarik jartzen.',
  },
};
